import { i18n } from '@lingui/core';
import { Space, Text } from '@mantine/core';
import { useContext } from 'react';
import { BookingStateIcon } from '../../../Atoms/StateIcon';
import BookingState from '../../../Types/Enums/BookingState';
import BookingStateItem from '../BookingStateItem';
import { EventsContext } from '../../../Service/Context/EventsContext';
import { useAppUser } from '../../../Service/Context/ApplicationUserContext';

const ListBookingStateSelection = () => {
  const { filter, updateFilter } = useContext(EventsContext);
  const { redGreenWeakness } = useAppUser();
  const { agencyModeActive, statesOfInterest } = filter;

  const toggleState = (state: any) => {
    let newState = Object.assign([], statesOfInterest);

    if (state === 'OPEN' || state === 'OFFERED' || state === 'BOOKED') {
      if (newState.includes(state)) {
        newState = newState.filter((s: any) => s !== state);
        updateFilter({ statesOfInterest: newState });
      } else {
        newState.push(state);
        updateFilter({ statesOfInterest: newState });
      }
    } else if (newState.includes(state)) {
      newState = newState.filter((s: any) => s !== state);
      updateFilter({ statesOfInterest: newState });
    } else {
      newState.push(state);
      updateFilter({ statesOfInterest: newState });
    }
  };

  return (
    <>
      <Space h="xl" />
      <Text pl={10}>{agencyModeActive ? 'Vermittlungsstatus' : 'Buchungsstatus'}</Text>
      <Space h="xs" />
      <BookingStateItem
        label={i18n._('event.state.open')}
        color="#1D5191"
        bgColor="#E8EEF4"
        onClick={() => toggleState(BookingState.OPEN)}
        active={statesOfInterest.includes(BookingState.OPEN)}
        icon={redGreenWeakness && <BookingStateIcon bookingState={BookingState.OPEN} size={16} />}
      />
      <BookingStateItem
        label={i18n._('event.state.offered')}
        color="#FDA632"
        bgColor="#FFF6EB"
        onClick={() => toggleState(BookingState.OFFERED)}
        active={statesOfInterest.includes(BookingState.OFFERED)}
        icon={redGreenWeakness && <BookingStateIcon bookingState={BookingState.OFFERED} size={16} />}
      />
      <BookingStateItem
        label={i18n._('event.state.booked')}
        color="#4EBF46"
        bgColor="#EDF9ED"
        onClick={() => toggleState(BookingState.BOOKED)}
        active={statesOfInterest.includes(BookingState.BOOKED)}
        icon={redGreenWeakness && <BookingStateIcon bookingState={BookingState.BOOKED} size={16} />}
      />
      <BookingStateItem
        label={i18n._('event.state.unavailable')}
        color="#757575"
        bgColor="#eeeeee"
        onClick={() => toggleState(BookingState.UNAVAILABLE)}
        active={statesOfInterest.includes(BookingState.UNAVAILABLE)}
        icon={redGreenWeakness && <BookingStateIcon bookingState={BookingState.UNAVAILABLE} size={16} />}
      />
      <BookingStateItem
        label={i18n._('event.state.canceled')}
        color="#f44336"
        bgColor="#ffebee"
        onClick={() => toggleState(BookingState.CANCELED)}
        active={statesOfInterest.includes(BookingState.CANCELED)}
        icon={redGreenWeakness && <BookingStateIcon bookingState={BookingState.CANCELED} size={16} />}
      />
    </>
  );
};

export default ListBookingStateSelection;
